export default "__VITE_ASSET__X_tNb7gj__"